var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LoadingCover',{staticClass:"loadingPage"},[_c('div',{staticClass:"loadingContainer"},[_c('b-spinner',{attrs:{"variant":"danger"}}),_c('p',[_vm._v(_vm._s(_vm.loadingText))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }